import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Images, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { exportPng } from "@/components/game/share";
import { useLang } from "@/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const toDataUrl = (blob) => new Promise((res) => { const r = new FileReader(); r.onload = () => res(r.result); r.readAsDataURL(blob); });

export const SaveToGallery = ({ svgRef, caption, game, bg, disabled }) => {
  const { t } = useLang();
  const s = t.gallery;
  const [open, setOpen] = useState(false);
  const [name, setName] = useState(localStorage.getItem("pame3d_kid") || "");
  const [busy, setBusy] = useState(false);
  const [saved, setSaved] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setBusy(true);
    try {
      const blob = await exportPng(svgRef.current, caption, bg);
      await axios.post(`${API}/creations`, { name: name.trim(), game, caption: caption.slice(0, 80), image: await toDataUrl(blob) });
      localStorage.setItem("pame3d_kid", name.trim());
      setSaved(true);
      toast.success(s.saved);
    } catch { toast.error(s.error); }
    setBusy(false);
  };

  return (
    <>
      <button data-testid="save-gallery-btn" onClick={() => { setSaved(false); setOpen(true); }} disabled={disabled}
        className="inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-xs md:text-sm font-semibold bg-[#C86A4B] text-white hover:bg-[#2E5A3B] transition-colors duration-200 disabled:opacity-40">
        <Images size={14} /> {s.save}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm bg-[#F7F5F0]" data-testid="save-gallery-dialog">
          <DialogHeader>
            <DialogTitle className="font-serif-d text-2xl text-[#132A1D]">{saved ? s.doneTitle : s.title}</DialogTitle>
            <DialogDescription className="text-[#5C5C5C]">{saved ? s.doneSub : s.sub}</DialogDescription>
          </DialogHeader>
          {saved ? (
            <Link to="/galeria" data-testid="save-gallery-view" className="inline-flex justify-center rounded-full bg-[#2E5A3B] text-white px-6 py-3 text-sm font-semibold hover:bg-[#C86A4B] transition-colors duration-200">{s.view}</Link>
          ) : (
            <form onSubmit={save} className="space-y-3">
              <input data-testid="save-gallery-name" value={name} onChange={(e) => setName(e.target.value)} maxLength={30} placeholder={s.namePh} required
                className="w-full rounded-xl border border-black/10 bg-white px-4 py-3 text-sm outline-none focus:border-[#2E5A3B]" />
              <button type="submit" data-testid="save-gallery-submit" disabled={busy || !name.trim()}
                className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#2E5A3B] text-white px-6 py-3 text-sm font-semibold hover:bg-[#C86A4B] transition-colors duration-200 disabled:opacity-50">
                {busy ? <Loader2 size={16} className="animate-spin" /> : <Images size={16} />} {s.submit}
              </button>
              <p className="text-[11px] text-[#5C5C5C]">{s.note}</p>
            </form>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
